import { Link } from "react-router-dom";

export const LinkLocation = ({ to, children, className, target }) => {
  return (
    <Link to={to} className={className} target={target}>
      {children}
    </Link>
  );
};
